import * as React from 'react';

import { LoginContainer } from '@/components/Containers/LoginContainer/LoginContainer';
import { NotFound } from '@/components/Layout';

export const privateRoutesNotLogged = [
  {
    path: '/account',
    element: <LoginContainer />,
    children: [
      { path: 'purchase', element: <NotFound /> },
      { path: 'products', element: <NotFound /> },
      { path: 'my-account', element: <NotFound /> },
      { path: 'my-rate', element: <NotFound /> },
      { path: 'my-invoices', element: <NotFound /> },
      { path: 'feature-comparator', element: <NotFound /> },
      { path: 'faqs', element: <NotFound /> },
      { path: '/account/', element: <NotFound /> },
      { path: '*', element: <NotFound /> },
    ],
  },
  {
    path: '/account/checkout',
    element: <LoginContainer />,
    children: [
      { path: ':mdirectorId', element: <NotFound /> },
      { path: ':mdirectorId/:comID', element: <NotFound /> },
      { path: ':mdirectorId/:interval/:comID', element: <NotFound /> },
      { path: '*', element: <NotFound /> },
    ],
  },
  {
    path: '/account/activation',
    element: <LoginContainer />,
    children: [
      { path: ':mdirectorId', element: <NotFound /> },
      { path: ':mdirectorId/:billingMode', element: <NotFound /> },
      { path: ':mdirectorId/:billingMode/:currency', element: <NotFound /> },
      { path: ':mdirectorId/:billingMode/:currency/:landingname', element: <NotFound /> },
      { path: '', element: <NotFound /> },
    ],
  },
];
